import { Avatar, Box, IconButton, Modal, Rating, Skeleton, Slide } from '@mui/material'
import { useEffect } from 'react'
import { rqx } from '../../../../core/request/API'
import { env } from '../../../../core/Env'
import { Close } from '@mui/icons-material';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const View = ({view, handlerView, details}) => {
    const { info, imgs } = details.data

    const ratings = [
        {name: 'Facilities', rate: info.facilities_rating},
        {name: 'Staff', rate: info.staff_rating},
        {name: 'Comfort', rate: info.comfort_rating},
        {name: 'Location', rate: info.location_rating},
    ]

    const settings ={
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    }

    const overAllTotal = () => {
        const { facilities_rating, staff_rating, comfort_rating, location_rating } = info
        const total = facilities_rating + staff_rating + comfort_rating + location_rating
        const average = total / 4
        return average
    } 

    useEffect(() => {
        const viewReview = async() => {
            const r = await rqx.get(`<<tool>>/${env()}/reviewsRatings/booking_review`, {id: view.data.id})
            const a = await rqx.get(`<<tool>>/${env()}/reviewsRatings/booking_review_attachment`, {id: view.data.id})
            details.set({...details.data , info : r[0] , imgs: a})
            view.set({...view.data, loader : false})
        }
        viewReview()
        // eslint-disable-next-line 
    },[view.data.show])
    
    return (
        <Modal open={view.data.show} onClose={() => handlerView()}>
            <Slide in={view.data.show} direction='left'
               
            >
                <Box
                    sx={{
                        position:'absolute',
                        top: '10%',
                        right: '2%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        width: '60vw',
                        height: '80vh',
                        borderRadius: '16px',
                        pb: 2,
                        pt: 1
                    }} 
                >
                    <Box display="flex" justifyContent="end" position="relative">
                        <IconButton sx={{position: 'absolute'}} onClick={() => handlerView()}>
                            <Close />
                        </IconButton>
                    </Box>
                    {
                        view.data.loader ?
                            <DsgLoader />
                        :
                            
                            <Box display="flex" flexDirection="column" gap="24px" width="100%" height="100%" className="overflowY"  p={4}> 
                             
                                <Box display="flex" alignItems="center" gap="8px">
                                    <Avatar variant='rounded' src={JSON.parse(info.designs)[0].featured_image} sx={{width: 60, height: 60}} />
                                    <Box fontSize="1rem" fontWeight={600}>{info.promo_name}</Box>
                                </Box>
                                <Box display="flex" gap="8px" fontSize="0.85rem" fontWeight={600}>
                                    <Box>Name: </Box>
                                    <Box sx={{textTransform: 'capitalize'}} >
                                        {
                                            info.first_name !== null || info.first_name !== '' ? (
                                                `${info.first_name} ${info.middle_name} ${info.last_name}`
                                            ):(
                                                info.mobile_num !== null || info.mobile_num !== '' ? (
                                                    info.mobile_num
                                                ):(
                                                    info.email
                                                )
                                            )  
                                        }
                                    </Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap="8px">
                                    <Box fontSize="0.85rem" fontWeight={600}>Overall Rating:</Box>
                                    <Rating name="overall"  precision={0.05} readOnly value={overAllTotal()} />
                                </Box>
                                <Box className="slider-container" textAlign="center">
                                    <Slider {...settings}>
                                        {
                                            imgs.map((v,k) => (
                                                <Box height={250} width="100%" key={k}>
                                                    <img src={v.link} alt={v.link}   style={{height: '100%', width: '100%', objectFit: 'fill'}} />
                                                </Box>
                                            ))
                                        }
                                    </Slider>
                                </Box>
                                <Box fontSize="0.85rem" fontWeight={600}>Reviews and Rating</Box>
                                {
                                    ratings.map((v,k) => (
                                        <Box display="flex" alignItems="center" key={k} gap="16px">
                                            <Box fontSize="0.875rem" fontWeight={600}>{v.name}:</Box>
                                            <Rating readOnly value={v.rate} />
                                        </Box>
                                    ))
                                }
                                <Box display="flex" flexDirection="column" gap="8px">
                                    <Box fontSize="0.875rem" fontWeight={600}>Tell us about your Exprience</Box>
                                    <Box border="1px solid #bdbdbd" p="8px" borderRadius="4px" color="#616161" minHeight={100} sx={{wordBreak: 'break-word'}}> 
                                        {info.experience_review}
                                    </Box>
                                </Box>
                            </Box>
                    }
                </Box>
            </Slide>
        </Modal>
    )
}

const DsgLoader = () => {
    return (
        <Box display="flex" flexDirection="column" gap="24px" width="100%" height="100%" className="overflowY" p={4}> 
             <Box display="flex" alignItems="center" gap="8px">
                <Skeleton variant='rounded' sx={{width: 60, height: 60}} />                    
                <Skeleton variant='text' width={150} />
            </Box>
            <Skeleton variant='text' width={150} />
            <Box  textAlign="center" width="100%">
                <Skeleton variant='rounded' sx={{width: '100%', height: 250}} />
            </Box>
            <Skeleton variant='text' width={200} />
                {
                    ['','','',''].map((v,k) => (
                        <Box display="flex" alignItems="center" key={k} gap="16px">
                            <Skeleton variant='text' width={80} />
                            <Skeleton variant='text' width={100} />
                        </Box>
                    ))
                }
            <Skeleton variant='text' width={200} />
            <Skeleton variant='rounded' sx={{height: 100}} />
        </Box>
    )
}